/**
 * Сторінка 403 Forbidden - відображається при відсутності прав доступу
 * Показує інформацію про роль користувача та необхідні права
 * @component ForbiddenPage
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { translate } from '../../locales';
import { PUBLIC_ROUTES } from '../../constants/routes';
import './ForbiddenPage.css';

interface ForbiddenPageProps {
  /**
   * Повідомлення про помилку (опційно)
   */
  message?: string;
  /**
   * Чи показувати кнопку повернення назад
   */
  showBackButton?: boolean;
  /**
   * Чи показувати кнопку переходу на головну
   */
  showHomeButton?: boolean;
}

const ForbiddenPage: React.FC<ForbiddenPageProps> = ({
  message,
  showBackButton = true,
  showHomeButton = true
}) => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  // Translation helper
  const t = (key: string) => translate(key as any, language as 'en' | 'ua');

  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate(PUBLIC_ROUTES.HOME);
    }
  };

  const handleGoHome = () => {
    navigate(PUBLIC_ROUTES.HOME);
  };

  return (
    <div className="forbidden-page">
      <div className="forbidden-container">
        <div className="forbidden-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 8L16 8L14 6L10 6L8 8L6 8C4.9 8 4 8.9 4 10L4 18C4 19.1 4.9 20 6 20L18 20C19.1 20 20 19.1 20 18L20 10C20 8.9 19.1 8 18 8ZM18 18L6 18L6 10L8 10L8 12L10 12L10 10L14 10L14 12L16 12L16 10L18 10L18 18ZM12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14Z"
              fill="currentColor"
            />
          </svg>
        </div>

        <div className="forbidden-content">
          <h1 className="forbidden-title">
            403 - {t('auth.error.accessDenied')}
          </h1>

          <p className="forbidden-message">
            {message || t('auth.error.insufficientRights')}
          </p>

          <div className="forbidden-actions">
            {showBackButton && (
              <button
                onClick={handleGoBack}
                className="forbidden-button forbidden-button-secondary"
              >
                ← Повернутися назад
              </button>
            )}

            {showHomeButton && (
              <button
                onClick={handleGoHome}
                className="forbidden-button forbidden-button-primary"
              >
                🏠 На головну
              </button>
            )}
          </div>

          <div className="forbidden-help">
            <p>
              Якщо ви вважаєте, що це помилка, зверніться до адміністратора системи.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForbiddenPage;
